var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyShareSharedKeyMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,26c-6.6171875,0-12-5.3828125-12-12c0-5.9343872,4.3336182-10.862793,10-11.819397V0.159729 C17.2268066,1.135376,12,6.9609985,12,14c0,5.956543,3.7456665,11.0422363,9,13.0609741v6.4673462 c0,0.4628906,0.109375,0.9267578,0.3164062,1.3408203l0.578125,1.15625C21.9638672,36.1630859,22,36.3173828,22,36.4716797 v7.7001953c0,0.8007812,0.3124943,1.5546875,0.8789062,2.1210938L23.5859375,47C24.2304688,47.6445312,25.0878906,48,26,48 s1.7695312-0.3554688,2.4140625-1l0.7070312-0.7070312C29.6874943,45.7265625,30,44.9726562,30,44.171875v-7.7001953 c0-0.1542969,0.0361328-0.3085938,0.1054688-0.4462891l0.578125-1.15625C30.890625,34.4550781,31,33.9912109,31,33.5283203 v-6.4673462C35.6538086,25.2729492,39.1090088,21.0765991,39.840271,16h-2.020874C36.862793,21.6663818,31.9343872,26,26,26z  M29,33.5283203c0,0.1542969-0.0361328,0.3085938-0.1054688,0.4462891l-0.578125,1.15625 C28.109375,35.5449219,28,36.0087891,28,36.4716797v7.7001953c0,0.2626953-0.1064453,0.5205078-0.2929688,0.7070312L27,45.5859375 c-0.5351562,0.5332031-1.4648438,0.5332031-2,0l-0.7070312-0.7070312C24.1064453,44.6923828,24,44.4345703,24,44.171875v-7.7001953 c0-0.4628906-0.109375-0.9267578-0.3164062-1.3408203l-0.578125-1.15625C23.0361328,33.8369141,23,33.6826172,23,33.5283203 v-5.8601685C23.9676514,27.8804321,24.9695435,28,26,28s2.0323486-0.1195679,3-0.3318481V33.5283203z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,14h2c0-7.7197266-6.2802734-14-14-14v2C32.6171875,2,38,7.3828125,38,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,14h1h1c0-5.5136719-4.4863281-10-10-10v2C30.4111328,6,34,9.5888672,34,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,14h2c0-3.3085938-2.6914062-6-6-6v2C28.2060547,10,30,11.7939453,30,14z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 14,
    r: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyShareSharedKeyMedium);
export default __webpack_public_path__ + "static/media/key-share-shared-key--medium.f13d2fb7d151574734ad5d35507df684.svg";
export { ForwardRef as ReactComponent };